import { render, staticRenderFns } from "./SignatureTemplateFivium.vue?vue&type=template&id=6f197232&scoped=true"
import script from "./SignatureTemplateFivium.vue?vue&type=script&lang=js"
export * from "./SignatureTemplateFivium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f197232",
  null
  
)

export default component.exports